import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createMultiCartComment } from 'api/cart/createMultiCartComment'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import { COMMENT_QUERY_KEY } from 'constants/comments'

interface CreateCommentParams {
  multiCartId: string
  itemId: string
  text: string
}

export function useCreateMultiCartComment() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: CreateCommentParams) => createMultiCartComment(
      params.multiCartId,
      params.itemId,
      params.text,
    ),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [COMMENT_QUERY_KEY, variables.multiCartId] })
    },
    onError: (error: Error) => {
      showSnackbar(`Failed to add comment: ${error.message}`, 'critical')
    },
  })
}
